import React, { useState, useEffect, createContext, useContext } from 'react';
import { GET_GROWER_BY_URN, UPDATE_GROWER, GET_STAKEHOLDER_BY_URN, ResourceUpdateMember, ALLOCATE_WORKFLOW, INITIATE_WORKFLOW_FOR_REG_SCRU, CHECK_USER_DISTRICT_MAPPING } from '../../../../common/URLs'

import jwt from 'jwt-decode';
import { useNavigate, useLocation } from 'react-router-dom';
import { getLocalStorageItem } from '../../../../common/localStorageUtils';
import { API_DATE_FORMAT, CONSTANTS, EMPTY_FIELD_ERROR, GST, PROD, RESOURCE_ROLES, ROLES } from '../../../../common/constants';
import { toast } from 'react-toastify';
import { getAllComments, insertComment } from '../commonRegistrationStakeholderAPIs';
import { loaderService } from '../../../../common/custom-loader/loader-service';
import { GetRecentCommentObject } from '../../../../common/commonFunction';
import BackButton from '../../../../common/backButton';
import { Button, Box, Typography, Grid, Stack, Container } from "@mui/material";
import { useTranslation } from "react-i18next";
import moment from 'moment';
import { VALIDATION } from '../../../../common/commonValidations';
import Preview from '../preview';
import { TextField } from '@mui/material';
import PersonalDetailsTransporter from './personalDetailsTransporter';
import VehicleDetailsTransporter from './vehicleDetailsTransporter';
import { BASIC_DATE_FORMAT } from '../../../../common/constants';
import { GET_ADDRESS_BY_IFSC, UPDATE_TRANSPORTER, authKey } from '../../../../common/URLs';
import { PreviewIcon, SaveIcon } from '../../../../common/icons';
import _ from 'lodash';
import { appInsights } from '../../../../AppInsights';
import apiClient from '../../../../axios';

const TransporterContext = createContext();

function RegistrationDetailsTransporter(props) {
    const { state } = useLocation();
    const urn = state?.URN ? state.URN : props.urn;
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [commentsData, setCommentsData] = useState();
    const [comments, setComments] = useState([]);
    const decoded = jwt(getLocalStorageItem('id_token'));
    let userRole = localStorage.getItem('role');
    let uuid = localStorage.getItem('uuid');
    const [expandedSection, setExpandedSection] = useState("personal");
    const [errorMessage, setErrorMessage] = useState({
        contactPersonFirstNameError: '',
        emailIdError: '',
        addressError: "",
        accountNumberError: '',
        accountHolderNameError: '',
        ifscCodeError: '',
        documentError: '',
        idProofDocError: '',
        addressProofDocError: '',
        tradeLicenseDocError: '',
        labourLicenseDocError: '',
        bankStatementError: '',
        bankDocError: '',
        fullNameError: '',
        applicantTypeError: '',
        personalCommentError: "",
        agreementCommentError: "",
        bankCommentError: "",
        gstNumberError: '',
        agreementDateError: '',
        documentError: '',
        manpowerVechicletableError: '',
        panDocError: ''
    });

    const [currentPage, setCurrentPage] = useState("registrationDetails");
    const [buttonAction, setButtonAction] = useState("");
    const [callUpdateApi, setCallUpdateApi] = useState(false);
    const [showCommentSection, setShowCommentSection] = useState(false);
    const [regScruResourceUpdate, setRegScruResourceUpdate] = useState(false);
    const [stakeHolderDetails, setStakeHolderDetails] = useState();
    const [showWorkFlowButtons, setShowWorkFlowButtons] = useState(false);
    const [showClarificationButton, setShowClarificationButton] = useState(false);
    const [enableSaveSubmitButtons, setEnableSaveSubmitButtons] = useState(false);
    const [personalDetailsSectionOk, setPersonalDetailsSectionOk] = useState(false);
    const [agreementDetailsSectionOk, setAgreementDetailsSectionOk] = useState(false);
    const [bankDetailsSectionOk, setBankDetailsSectionOk] = useState(false);
    const [vehicleDetailsSectionOk, setVehicleDetailsSectionOk] = useState(false);
    const [shouldActOnSection, setShouldActOnSection] = useState({
        personal_details: false,
        bank_details: false,
        agreement_details: false,
        vehicle_details: false
    });
    const [callWorkFlowApi, setCallWorkFlowApi] = useState(false);
    const [verifyMobileNo, setVerifyMobileNo] = useState(false);
    const [mobileOTPValidated, setMobileOTPValidated] = useState(false);
    const [otpHidden, setOtpHidden] = useState(true);
    const [otpValue, setOtpValue] = useState()
    const [transporterDetails, setTransporterDetails] = useState();
    // const [transporterDrivers, setTransporterDrivers] = useState([]);
    // const [transporterVehicle, setTransporterVehicle] = useState([]);
    const [documentArray, setDocumentArray] = useState([]);
    const [otherIdType, setOtherIdType] = useState({
        otherGovtCardType: '',
    });

    const [contactPersonDetails, setContactPersonDetails] = useState({
        contactPersonFirstName: '',
        contactPersonMiddleName: '',
        contactPersonLastName: '',
        contactPersonSalutation: 'Mr',
        contactPersonGender: 'Male',

    });
    const [addressDetails, setAddressDetails] = useState({
        address: '',
        pincode: '',
        state: '',
        district: '',
        subDivision: '',
        revenueCircle: '',
        blockName: ''

    });

    const [id, setId] = useState('');
    const [fullName, setFullName] = useState(transporterDetails?.name);
    const [applicantType, setApplicantType] = useState('');
    const [mobileNumber, setMobileNumber] = useState('');
    const [mobileNumberError, setMobileNumberError] = useState('');
    const [emailId, setEmailId] = useState('');
    const [registrationCompleted, setRegistrationCompleted] = useState();
    const [govIDType, setGovIDType] = useState("Government ID");
    const [govIDNumber, setGovIDNumber] = useState('');
    const [govIDNumberVisible, setGovIDNumberVisible] = useState(false);
    const [nextClick, setNextClick] = useState(false);
    const [panNumber, setPanNumber] = useState('');
    const [certificateType, setCertificateType] = useState('');
    const [certificateNumber, setCertificateNumber] = useState('');
    const [tradeLicenseNo, setTradeLicenseNo] = useState('');
    const [tradeLicenseEndDate, setTradeLicenseEndDate] = useState('');
    const [tradeLicenseEndDateDisplay, setTradeLicenseEndDateDisplay] = useState('');
    // Bank Details
    const [bankDetails, setBankDetails] = useState();
    const [accountNumber, setAccountNumber] = useState('');
    const [accountHolderName, setAccountHolderName] = useState('');
    const [branchName, setBranchName] = useState('');
    const [ifscCode, setIfscCode] = useState('');
    const [bankName, setBankName] = useState('');

    const [vehicleDataDisplay, setVehicleDataDisplay] = useState([]);

    const [dataFromVehiclePopover, setDataFromVehiclePopover] = useState([]);
    const [dataFromDriverPopover, setDataFromDriverPopover] = useState([]);
    const [selectedArea, setSelectedArea] = useState([]);
    const [selectedAreaApi, setSelectedAreaApi] = useState([]);
    const [totalManpower, setTotalManpower] = useState('');
    const [totalVehicleCount, setVehicleCount] = useState('');
    const [gstNumber, setGstNumber] = useState('');
    const [agreementStartDate, setAgreementStartDate] = useState('');
    const [agreementStartDisplay, setAgreementStartDisplay] = useState('');
    const [agreementEndDate, setAgreementEndDate] = useState('');
    const [agreementEndDisplay, setAgreementEndDisplay] = useState('');
    const [vehiclePregDetails, setVehiclePregDetails] = useState({
        noOfLcvVehicleOwned: 0,
        noOfLcvVehicleRented: 0,
        noOfMcvVehicleOwned: 0,
        noOfMcvVehicleRented: 0,
        noOfHcvVehicleOwned: 0,
        noOfHcvVehicleRented: 0,
        existingAreaOfOperation: "",
    });

    // const driverDataFromAPi = (e) => {
    //     if ((transporterDetails?.transporterMasters[0]?.transporterDrivers.length !== 0)) {
    //         let tempDriverData = transporterDetails?.transporterMasters[0]?.transporterDrivers
    //         setTransporterDrivers(tempDriverData)
    //     }
    // }

    // const vehicleDataFromApi = () => {
    //     if ((transporterDetails?.transporterMasters[0]?.transporterVehicles.length !== 0)) {
    //         let tempVehicleArr = transporterDetails?.transporterMasters[0]?.transporterVehicles
    //         setTransporterVehicle(tempVehicleArr)
    //     }
    // }
    const [isMSMERadio, setIsMSMERadio] = useState("NO");
    const [msmeCategory, setMsmeCategory] = useState("");

    useEffect(() => {
        if (transporterDetails) {
            let docType = transporterDetails?.transporterMasters[0].documents
            let tradeLicenseEndDateApiValue = transporterDetails.transporterMasters[0].tradeLicenseEndDate
            setId(transporterDetails?.id)
            setFullName(transporterDetails.name)
            setApplicantType(transporterDetails.transporterMasters[0] ? transporterDetails.transporterMasters[0]?.applicantType : '',)
            setMobileNumber(transporterDetails.mobileNo)
            setEmailId(transporterDetails.emailId)
            setAccountNumber(transporterDetails.bankAccountNumber)
            setAccountHolderName(transporterDetails.bankAccountHolderName)
            setBranchName(transporterDetails.bankBranch)
            setIfscCode(transporterDetails.bankIfscCode)
            setBankName(transporterDetails.bankName)
            setPanNumber(transporterDetails.panNumber)
            setGovIDType(transporterDetails.govtIdCardType)
            setOtherIdType(transporterDetails.otherGovtCardType)
            setGovIDNumberVisible(transporterDetails.govtIdCardType === "AAdhar ID" ? true : false)
            setGovIDNumber(transporterDetails.govtIdCardNumber ? transporterDetails.govtIdCardNumber : '')
            setContactPersonDetails({
                ...contactPersonDetails,
                contactPersonFirstName: transporterDetails.contactPersonFirstname,
                contactPersonMiddleName: transporterDetails.contactPersonMiddlename,
                contactPersonLastName: transporterDetails.contactPersonLastname,
                contactPersonSalutation: transporterDetails.contactPersonSalutation ? transporterDetails.contactPersonSalutation : 'Mr',
                contactPersonGender: transporterDetails.contactPersonGender ? transporterDetails.contactPersonGender : 'Male',

            });
            setAddressDetails({
                ...addressDetails,
                address: transporterDetails.transporterMasters[0] ? transporterDetails.transporterMasters[0]?.address : '',
                pincode: transporterDetails.transporterMasters[0] ? transporterDetails.transporterMasters[0]?.pincode : '',
                state: transporterDetails.transporterMasters[0] ? transporterDetails.transporterMasters[0]?.state : 'State',
                district: transporterDetails.transporterMasters[0] ? transporterDetails.transporterMasters[0]?.district : 'District',
                subDivision: transporterDetails.transporterMasters[0] ? transporterDetails.transporterMasters[0]?.subDivision : '',
                revenueCircle: transporterDetails.transporterMasters[0] ? transporterDetails.transporterMasters[0]?.revenueCircle : '',
                blockName: transporterDetails.transporterMasters[0] ? transporterDetails.transporterMasters[0]?.blockName : '',
            })
            setTradeLicenseNo(transporterDetails.transporterMasters[0].transportationTradeLicenseNo)
            setTradeLicenseEndDate(tradeLicenseEndDateApiValue ? tradeLicenseEndDateApiValue : null)
            setTradeLicenseEndDateDisplay(tradeLicenseEndDateApiValue ? moment(tradeLicenseEndDateApiValue).format(BASIC_DATE_FORMAT) : null)
            setCertificateNumber(transporterDetails.transporterMasters[0].certificateNumber)
            setCertificateType(transporterDetails.transporterMasters[0].certificateType ? transporterDetails.transporterMasters[0].certificateType : CONSTANTS.ID_PROOF_ARRAY[0])
            setDocumentArray(transporterDetails.transporterMasters[0].documents)
            setRegistrationCompleted(transporterDetails.registrationCompleted)
            // driverDataFromAPi();
            // vehicleDataFromApi();
            let agreementStartDateApiValue = transporterDetails?.transporterMasters[0]?.agreementStartDate
            let agreementEndDateApiValue = transporterDetails?.transporterMasters[0]?.agreementEndDate
            const totalManpowerConcatenateValue = parseInt(transporterDetails?.transporterMasters[0]?.transporterDrivers.length)
            const totalVehicleConcatenateValue = parseInt(transporterDetails?.transporterMasters[0]?.transporterVehicles.length)
            setTotalManpower(totalManpowerConcatenateValue)
            setVehicleCount(totalVehicleConcatenateValue)
            setGstNumber(transporterDetails?.transporterMasters[0]?.gstNumber)
            setDataFromVehiclePopover(transporterDetails?.transporterMasters[0]?.transporterVehicles)
            setDataFromDriverPopover(transporterDetails?.transporterMasters[0]?.transporterDrivers)
            setAgreementStartDate(agreementStartDateApiValue ? agreementStartDateApiValue : null)
            setAgreementStartDisplay(agreementStartDateApiValue ? moment(agreementStartDateApiValue).format(BASIC_DATE_FORMAT) : null)
            setAgreementEndDate(agreementEndDateApiValue ? agreementEndDateApiValue : null)
            setAgreementEndDisplay(agreementEndDateApiValue ? moment(agreementEndDateApiValue).format(BASIC_DATE_FORMAT) : null)
            setVehiclePregDetails({
                ...vehiclePregDetails,
                noOfLcvVehicleOwned: transporterDetails?.transporterMasters[0]?.noOfLcvVehicleOwned,
                noOfLcvVehicleRented: transporterDetails?.transporterMasters[0]?.noOfLcvVehicleRented,
                noOfMcvVehicleOwned: transporterDetails?.transporterMasters[0]?.noOfMcvVehicleOwned,
                noOfMcvVehicleRented: transporterDetails?.transporterMasters[0]?.noOfMcvVehicleRented,
                noOfHcvVehicleOwned: transporterDetails?.transporterMasters[0]?.noOfHcvVehicleOwned,
                noOfHcvVehicleRented: transporterDetails?.transporterMasters[0]?.noOfHcvVehicleRented,
                existingAreaOfOperation: transporterDetails?.transporterMasters[0]?.existingAreaOfOperation.length === 0 ? "N/A" :
                    transporterDetails?.transporterMasters[0]?.existingAreaOfOperation,
            })
            setVehicleDataDisplay([
                {
                    vehicleType: "LCV",
                    ownedVehicles: transporterDetails?.transporterMasters[0]?.noOfLcvVehicleOwned,
                    rentedVehicles: transporterDetails?.transporterMasters[0]?.noOfLcvVehicleRented
                },
                {
                    vehicleType: "MCV",
                    ownedVehicles: transporterDetails?.transporterMasters[0]?.noOfMcvVehicleOwned,
                    rentedVehicles: transporterDetails?.transporterMasters[0]?.noOfMcvVehicleRented,
                },
                {
                    vehicleType: "HCV",
                    ownedVehicles: transporterDetails?.transporterMasters[0]?.noOfHcvVehicleOwned,
                    rentedVehicles: transporterDetails?.transporterMasters[0]?.noOfHcvVehicleRented,
                },])
            setSelectedArea(transporterDetails?.transporterMasters[0]?.existingAreaOfOperation.split(","))
            setDocumentArray(transporterDetails?.transporterMasters[0]?.documents)
            setSelectedAreaApi(selectedAreaApi ? selectedAreaApi :
                transporterDetails?.transporterMasters[0]?.existingAreaOfOperation)
            setIsMSMERadio(
                transporterDetails?.isMSME === 1 ? "YES" : "NO"
            );

            setMsmeCategory(
                transporterDetails?.msmeCategory || ""
            );
        }

    }, [transporterDetails]);

    useEffect(() => {
        if (bankDetails) {
            setBranchName(bankDetails?.branch)
            setBankName(bankDetails?.bank)
        }
    }, [bankDetails]);

    const enableFieldFunction = (sectionEnabled, isPreg, isNew) => {
        if (state?.viewOnly) {
            return false
        }
        if (userRole === ROLES.ItAdmin) {
            return true
        }
        if (
            userRole === ROLES.RegistrationScruitnizer &&
            state?.userType === "Internal"
        ) { return true; }
        else if (enableSaveSubmitButtons && sectionEnabled && !isPreg) {
            return true
        }
        else if (isNew) {
            return true
        }
        else return false
    }

    const getStakeholderDetailsFromUrn = () => {
        loaderService.showLoader();
        apiClient.post(GET_STAKEHOLDER_BY_URN,
            {
                "urn": urn,
                "type": "transporter",
                "includeRejected": true,
                "isScrutinyView": true

            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                }
            }, null
        )
            .then((response) => {
                loaderService.hideLoader();
                let stakeHolderDetailsLocal = response.data.stakeHolder;
                setStakeHolderDetails(response.data.stakeHolder);
                setTransporterDetails(response.data.stakeHolder);
                if (stakeHolderDetailsLocal) {
                    const loggedInUser = decoded.extension_URN ? stakeHolderDetailsLocal?.id : uuid
                    if (stakeHolderDetailsLocal?.registrationStatus === "Scrutiny_Initiated" && stakeHolderDetailsLocal?.scrutinyStatus !== "Approved" && stakeHolderDetailsLocal?.scrutinyStatus !== "Rejected"
                        &&
                        (userRole === ROLES.RegistrationScruitnizer || decoded.extension_URN || userRole === ROLES.RegInCharge || userRole === ROLES.LeadRegScrutinizer || userRole === ROLES.RegSuperVisor)
                    ) {
                        setShowCommentSection(true);
                    }
                    if ((stakeHolderDetailsLocal?.scrutinyStatus === "Approved" || stakeHolderDetailsLocal?.registrationStatus === "ResourceUpdate_Initiated") && (userRole === ROLES.RegistrationScruitnizer && state?.userType === "Internal")) {
                        setShowCommentSection(true);
                        setRegScruResourceUpdate(true);
                    }
                    if (stakeHolderDetailsLocal?.scrutinyStatus !== "Rejected" && (userRole === ROLES.ItAdmin || userRole === RESOURCE_ROLES.PlantSCMMember || (decoded.extension_URN && (stakeHolderDetailsLocal?.scrutinyStatus === "Approved" || (!stakeHolderDetailsLocal?.registrationCompleted && stakeHolderDetailsLocal?.registrationStatus !== "Scrutiny_Initiated"))) || (userRole === ROLES.RegistrationScruitnizer && stakeHolderDetailsLocal?.registrationStatus === "Scrutiny_Initiated" && !stakeHolderDetailsLocal?.registrationCompleted) || (userRole === ROLES?.RegistrationScruitnizer && state?.userType === "Internal" && stakeHolderDetailsLocal?.scrutinyStatus === "Approved"))) {
                        setEnableSaveSubmitButtons(true);
                    }
                    if (stakeHolderDetailsLocal?.registrationCompleted && stakeHolderDetailsLocal?.currentOwnerID === loggedInUser && stakeHolderDetailsLocal?.scrutinyStatus !== "Approved" && stakeHolderDetailsLocal?.scrutinyStatus !== "Rejected") {
                        // && state?.registerByScruOtpValidated for otp validation in pending clarification add after userole in below line
                        if (((userRole === ROLES.RegistrationScruitnizer) || decoded.extension_URN) && stakeHolderDetailsLocal?.scrutinyStatus == "Pending_Clarification") {
                            setShowClarificationButton(true);
                            setEnableSaveSubmitButtons(true);
                        }
                        if (userRole === ROLES.RegInCharge || userRole === ROLES.LeadRegScrutinizer || (userRole === ROLES.RegistrationScruitnizer && stakeHolderDetailsLocal?.scrutinyStatus != "Pending_Clarification")) {
                            setShowWorkFlowButtons(true);
                        }
                    }
                    getAllComments(stakeHolderDetailsLocal?.transporterMasters[0]?.regStakeholderMasterId, setCommentsData);
                }
            })
            .catch(function (error) {
                loaderService.hideLoader();
                console.log(error);
            });

    }

    useEffect(() => {
        const loggedInUser = decoded.extension_URN ? stakeHolderDetails?.id : uuid
        setComments(commentsData);
        let personalCommentsInitial = commentsData?.filter((item) => item.sectionName === "personal_details");
        let bankCommentsInitial = commentsData?.filter((item) => item.sectionName === "bank_details");
        let agreementCommentsInitial = commentsData?.filter((item) => item.sectionName === "agreement_details");
        let vehicleCommentsInitial = commentsData?.filter((item) => item.sectionName === "vehicle_details");
        setPersonalDetailsSectionOk(GetRecentCommentObject(personalCommentsInitial)?.sectionOk ? GetRecentCommentObject(personalCommentsInitial)?.sectionOk : false);
        setBankDetailsSectionOk(GetRecentCommentObject(bankCommentsInitial)?.sectionOk ? GetRecentCommentObject(bankCommentsInitial)?.sectionOk : false);
        setAgreementDetailsSectionOk(GetRecentCommentObject(agreementCommentsInitial)?.sectionOk ? GetRecentCommentObject(agreementCommentsInitial)?.sectionOk : false);
        setVehicleDetailsSectionOk(GetRecentCommentObject(vehicleCommentsInitial)?.sectionOk ? GetRecentCommentObject(vehicleCommentsInitial)?.sectionOk : false);
        if (!enableSaveSubmitButtons && !showWorkFlowButtons && !showClarificationButton) {
            Object.keys(shouldActOnSection).forEach(key => {
                shouldActOnSection[key] = false;
            });
        }
        else if (userRole === RESOURCE_ROLES.PlantSCMMember) {
            Object.keys(shouldActOnSection).forEach(key => {
                shouldActOnSection[key] = false;
            });
        }
        else if (stakeHolderDetails?.scrutinyStatus === "Pending_Clarification" && stakeHolderDetails?.currentOwnerID === loggedInUser) {
            Object.keys(shouldActOnSection).forEach(key => {
                const section = commentsData?.find(obj => obj.sectionName === key && obj.isActive === 1);
                shouldActOnSection[key] = !section?.sectionOk;
            });
        }
        else {
            Object.keys(shouldActOnSection).forEach(key => {
                shouldActOnSection[key] = true;
            });
        }
    }, [commentsData]);

    useEffect(() => {
        if (urn) {
            getStakeholderDetailsFromUrn();
        }
    }, [urn]);

    useEffect(() => {
        if (callUpdateApi) {
            appInsights.trackEvent({
                name: 'Details Changed',
                properties: {
                    timeStamp: new Date().toISOString(),
                    user: decoded.extension_URN ? decoded.extension_URN : localStorage.getItem('email')
                }
            })
            if (buttonAction === "submit" && userRole === ROLES?.RegistrationScruitnizer && state?.userType === "Internal") {
                onCheckUserDistrictMapping();
            }
            else updateTransporter();
        }
    }, [callUpdateApi]);

    const onCheckUserDistrictMapping = () => {
        loaderService.showLoader();
        apiClient.post(CHECK_USER_DISTRICT_MAPPING,
            {
                "state": stakeHolderDetails?.transporterMasters?.[0]?.state,
                "plotDistrict": stakeHolderDetails?.transporterMasters?.[0]?.district
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                }
            }, null
        )
            .then((response) => {
                if (response.data.isSuccess === true) {
                    updateTransporter();
                } else {
                    toast.error(response.data?.message)
                }
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();

            });
    };

    const getRegistrationStatus = (submit) => {
        var regStatus = transporterDetails?.registrationStatus;
        if (userRole != ROLES.ItAdmin) {
            if (regStatus === "Approved" && ResourceUpdateMember.includes(userRole) || (userRole === ROLES?.RegistrationScruitnizer && state?.userType === "Internal")) {
                regStatus = "ResourceUpdate_Initiated";
            }
        }
        return regStatus;
    }
    const getResourceUpdateFlag = () => {
        var isApprovedStakeholder = stakeHolderDetails?.isApprovedStakeholder;
        if (userRole != ROLES.ItAdmin && isApprovedStakeholder) {
            return true;
        }
        return false;
    }

    const getSubmit = () => {
        if (userRole !== ROLES.ItAdmin && buttonAction === "submit") {
            return true
        }
        else {
            return false
        }
    }

    const checkValidations = () => {
        if (applicantType?.length == 0) {
            setErrorMessage({ applicantTypeError: "Please enter Applicant Type" });
            toast.error("Please enter Applicant Type");
            setExpandedSection("personal");
            return;
        }
        if (fullName?.length == 0) {
            setErrorMessage({ fullNameError: "Please enter Full Name" });
            toast.error("Please enter Full Name");
            setExpandedSection("personal");
            return;
        }
        if (contactPersonDetails.contactPersonFirstName?.length == 0) {
            setErrorMessage({ contactPersonFirstNameError: "Please enter first name" });
            toast.error("Please enter first name");
            setExpandedSection("personal");
            return;
        }
        if (emailId?.length == 0) {
            setErrorMessage({ emailIdError: "Please enter email address" });
            toast.error("Please enter email address");
            setExpandedSection("personal");
            return;
        }
        if (addressDetails?.address?.length == 0) {
            setErrorMessage({ addressError: "Please enter address" });
            toast.error("Please enter address");
            setExpandedSection("personal");
            return;
        }
        if (addressDetails.pincode?.length !== 6) {
            setErrorMessage({ pincodeError: EMPTY_FIELD_ERROR });
            toast.error(EMPTY_FIELD_ERROR);
            setExpandedSection("personal");
            return;
        }
        if (addressDetails.state?.length == 0) {
            setErrorMessage({ searchError: EMPTY_FIELD_ERROR });
            toast.error(EMPTY_FIELD_ERROR);
            setExpandedSection("personal");
            return;
        }
        if (userRole !== ROLES.ItAdmin) {
            if (!panNumber || panNumber?.length == 0) {
                setErrorMessage({ ...errorMessage, panNumberError: "Please enter PAN Number" });
                toast.error("Please enter PAN Number");
                setExpandedSection("personal");
                return;
            }
            var panDoc = documentArray && documentArray.filter((item) => item.documentType === "PANCard" && (item.isActive == 1 || item.isActive == 3));
            if (panDoc.length == 0) {
                setErrorMessage({ panDocError: "Please upload PAN document" });
                toast.error("Please upload PAN document");
                setExpandedSection("personal");
                return;
            }
            if (panNumber && panNumber?.length > 0 && !VALIDATION.panNumberValidation(panNumber)) {
                setErrorMessage({ ...errorMessage, panNumberError: "Please enter valid PAN Number" });
                toast.error("Please enter valid PAN Number");
                setExpandedSection("personal");
                return;
            }
            if (!certificateNumber || certificateNumber?.length == 0) {
                setErrorMessage({ certificateNumberError: "Please enter ID Proof Number" });
                toast.error("Please enter ID Proof Number");
                setExpandedSection("personal");
                return;
            }
            //else if (!tradeLicenseNo || tradeLicenseNo?.length == 0) {
            //    setErrorMessage({ tradeLicenseNoError: "Please enter Trade License No " });
            //    toast.error("Please enter Trade License No ");
            //    setExpandedSection("personal");
            //    return;
            //}
            var idProof = documentArray && documentArray.filter((item) => item.documentType === "MOA_RegistrationCertificate" && (item.isActive == 1 || item.isActive == 3));
            if (idProof?.length == 0) {
                setErrorMessage({ idProofDocError: "Please upload registration certificate" });
                toast.error("Please upload registration certificate");
                setExpandedSection("personal");
                return;
            }
            //var tardeLicense = documentArray && documentArray.filter((item) => item.documentType === "TransportationTradeLicense" && item.isActive == 1);
            //if (tardeLicense?.length == 0) {
            //    setErrorMessage({ tradeLicenseDocError: "Please upload transportation trade license document" });
            //    toast.error("Please upload transportation trade license document");
            //    setExpandedSection("personal");
            //    return;
            //}
            if (applicantType !== "Individual" && isMSMERadio === "YES") {

                if (!msmeCategory) {
                    toast.error("Please select MSME category");
                    setExpandedSection("personal");
                    return;
                }

                const msmeDoc = documentArray?.filter(
                    item =>
                        item.documentType === "MSME_Certificate" &&
                        (item.isActive === 1 || item.isActive === 3)
                );

                if (!msmeDoc || msmeDoc.length === 0) {
                    setErrorMessage({
                        ...errorMessage,
                        msmeDocError: "Please upload MSME certificate"
                    });
                    toast.error("Please upload MSME certificate");
                    setExpandedSection("personal");
                    return;
                }
            }
            if (!accountNumber || accountNumber?.length == 0 || !VALIDATION.bankAccountNumberValidation(accountNumber)) {
                setErrorMessage({ accountNumberError: "Please enter valid Account Number" });
                toast.error("Please enter valid Account Number");
                setExpandedSection("bank");
                return;
            }
            else if (!accountHolderName || accountHolderName?.length == 0 || !VALIDATION.bankAccountNameValidation(accountHolderName)) {
                setErrorMessage({ accountHolderNameError: "Please enter Account Holder's Name" });
                toast.error("Please enter Account Holder's Name");
                setExpandedSection("bank");
                return;
            }
            else if (!ifscCode || ifscCode?.length == 0 || !VALIDATION.ifscValidation(ifscCode)) {
                setErrorMessage({ ifscCodeError: "Please enter valid IFSC Code" });
                toast.error("Please enter valid IFSC Code");
                setExpandedSection("bank");
                return;
            }
            else if (!branchName || branchName?.length == 0) {
                setErrorMessage({ ifscCodeError: "Please enter valid IFSC code and search" });
                toast.error("Please enter valid IFSC code and search");
                setExpandedSection("bank");
                return;

            }
            var bankdoc = documentArray && documentArray.filter((item) => item.documentType === "BankPassBook_CancelledCheque" && (item.isActive == 1 || item.isActive == 3));
            if (bankdoc?.length == 0) {
                setErrorMessage({ bankDocError: "Please upload bank document" });
                toast.error("Please upload bank document");
                setExpandedSection("bank");
                return;
            }
            var bankStatement = documentArray && documentArray.filter((item) => item.documentType === "BankStatement" && (item.isActive == 1 || item.isActive == 3));
            if (bankStatement?.length == 0) {
                setErrorMessage({ bankStatementError: "Please upload bank statement" });
                toast.error("Please upload bank statement");
                setExpandedSection("bank");
                return;
            }
            if (!gstNumber || gstNumber?.length == 0) {
                setErrorMessage({ ...errorMessage, gstNumberError: 'Please enter valid GST Number' });
                toast.error('Please enter valid GST Number');
                setExpandedSection("agreement");
                return;
            }
            var gstDoc = documentArray && documentArray.filter((item) => item.documentType === GST && (item.isActive == 1 || item.isActive == 3));
            if (!gstDoc || gstDoc.length == 0) {
                setErrorMessage({ gstDocError: "Please upload gst document" });
                toast.error("Please upload gst document");
                setExpandedSection("agreement");
                return;
            }
            //if (dataFromDriverPopover.length == 0 || dataFromVehiclePopover.length == 0) {
            //    setErrorMessage({ ...errorMessage, manpowerVechicletableError: "Please add atleast one Driver & Vehicle Details" })
            //    toast.error("Please add atleast one Driver & Vehicle Details");
            //    setExpandedSection("vehicle");
            //    return;
            //}
        }
        showPreview();
    }

    const initialData = {
        "id": stakeHolderDetails?.id,
        "name": stakeHolderDetails?.name,
        "contactPersonName": stakeHolderDetails?.contactPersonName,
        "contactPersonFirstname": stakeHolderDetails?.contactPersonFirstname,
        "contactPersonMiddlename": stakeHolderDetails?.contactPersonMiddlename,
        "contactPersonLastname": stakeHolderDetails?.contactPersonLastname,
        "contactPersonGender": stakeHolderDetails?.contactPersonGender,
        "contactPersonSalutation": stakeHolderDetails?.contactPersonSalutation,
        "mobileNo": stakeHolderDetails?.mobileNo,
        "bankAccountNumber": stakeHolderDetails?.bankAccountNumber,
        "bankAccountHolderName": stakeHolderDetails?.bankAccountHolderName,
        "bankBranch": stakeHolderDetails?.bankBranch,
        "bankIfscCode": stakeHolderDetails?.bankIfscCode,
        "bankName": stakeHolderDetails?.bankName,
        "panNumber": stakeHolderDetails?.panNumber,
        "govtIdCardType": stakeHolderDetails?.govtIdCardType,
        "govtIdCardNumber": stakeHolderDetails?.govtIdCardNumber,
        "otherGovtCardType": stakeHolderDetails?.otherGovtCardType,
        "emailId": stakeHolderDetails?.emailId,
        "category": stakeHolderDetails?.category,
        "urn": stakeHolderDetails?.urn,
        "registrationCompleted": stakeHolderDetails?.registrationCompleted,
        "isOtpValidated": stakeHolderDetails?.isOtpValidated,
        "preregistrationShortlisted": stakeHolderDetails?.preregistrationShortlisted,
        "registrationStatus": stakeHolderDetails?.registrationStatus,
        "scrutinyStatus": stakeHolderDetails?.scrutinyStatus,
        "stakeholderStatus": stakeHolderDetails?.stakeholderStatus,
        "createdOn": stakeHolderDetails?.createdOn,
        "createdBy": stakeHolderDetails?.createdBy,
        "updatedOn": stakeHolderDetails?.updatedOn,
        "updatedBy": stakeHolderDetails?.updatedBy,
        "isActive": stakeHolderDetails?.isActive,
        "acceptedTerms": stakeHolderDetails?.acceptedTerms,
        "isResourceUpdate": getResourceUpdateFlag(),
        "transporterDetail": {
            "id": stakeHolderDetails?.transporterMasters[0]?.id,
            "regStakeholderMasterId": stakeHolderDetails?.transporterMasters[0]?.regStakeholderMasterId,
            "pincode": stakeHolderDetails?.transporterMasters[0]?.pincode,
            "address": stakeHolderDetails?.transporterMasters[0]?.address,
            "state": stakeHolderDetails?.transporterMasters[0]?.state,
            "district": stakeHolderDetails?.transporterMasters[0]?.district,
            "subDivision": stakeHolderDetails?.transporterMasters[0]?.subDivision,
            "revenueCircle": stakeHolderDetails?.transporterMasters[0]?.revenueCircle,
            "blockName": stakeHolderDetails?.transporterMasters[0]?.blockName,
            "transportationTradeLicenseNo": stakeHolderDetails?.transporterMasters[0]?.transportationTradeLicenseNo,
            "tradeLicenseEndDate": stakeHolderDetails?.transporterMasters[0]?.tradeLicenseEndDate,
            "gstNumber": stakeHolderDetails?.transporterMasters[0]?.gstNumber,
            "bankStatement": stakeHolderDetails?.transporterMasters[0]?.bankStatement,
            "totalManpower": Number(stakeHolderDetails?.transporterMasters[0]?.totalManpower),
            "companyType": stakeHolderDetails?.transporterMasters[0]?.companyType,
            "locationGeocode": stakeHolderDetails?.transporterMasters[0]?.locationGeocode,
            "documentId": stakeHolderDetails?.transporterMasters[0]?.documentId,
            "applicantType": stakeHolderDetails?.transporterMasters[0]?.applicantType,
            "noOfLcvVehicleOwned": Number(stakeHolderDetails?.transporterMasters[0]?.noOfLcvVehicleOwned),
            "noOfLcvVehicleRented": Number(stakeHolderDetails?.transporterMasters[0]?.noOfLcvVehicleRented),
            "noOfMcvVehicleOwned": Number(stakeHolderDetails?.transporterMasters[0]?.noOfMcvVehicleOwned),
            "noOfMcvVehicleRented": Number(stakeHolderDetails?.transporterMasters[0]?.noOfMcvVehicleRented),
            "noOfHcvVehicleOwned": Number(stakeHolderDetails?.transporterMasters[0]?.noOfHcvVehicleOwned),
            "noOfHcvVehicleRented": Number(stakeHolderDetails?.transporterMasters[0]?.noOfHcvVehicleRented),
            "existingAreaOfOperation": stakeHolderDetails?.transporterMasters[0]?.existingAreaOfOperation,
            "certificateType": stakeHolderDetails?.transporterMasters[0]?.certificateType,
            "certificateNumber": stakeHolderDetails?.transporterMasters[0]?.certificateNumber,
            "agreementStartDate": stakeHolderDetails?.transporterMasters[0]?.agreementStartDate,
            "agreementEndDate": stakeHolderDetails?.transporterMasters[0]?.agreementEndDate,
            "createdOn": stakeHolderDetails?.transporterMasters[0]?.createdOn,
            "createdBy": stakeHolderDetails?.transporterMasters[0]?.createdBy,
            "updatedOn": stakeHolderDetails?.transporterMasters[0]?.updatedOn,
            "updatedBy": stakeHolderDetails?.transporterMasters[0]?.updatedBy,
            "isActive": stakeHolderDetails?.transporterMasters[0]?.isActive,
            "documents": stakeHolderDetails?.transporterMasters[0]?.documents,
            "transporterVehicles": stakeHolderDetails?.transporterMasters[0]?.transporterVehicles,
            "transporterDrivers": stakeHolderDetails?.transporterMasters[0]?.transporterDrivers,
            "isMSME": stakeHolderDetails?.isMSME,
            "msmeCategory": stakeHolderDetails?.msmeCategory,
        }
    }

    const isMSMENo =
        isMSMERadio === 0 ||
        isMSMERadio === "NO";

    const filteredDocuments = documentArray?.map(doc => {
        if (doc.documentType === "MSME_Certificate") {
            return {
                ...doc,
                isActive: isMSMENo ? 0 : 1
            };
        }
        return doc;
    });

    const finalData = {
        "id": id,
        "name": fullName,
        "contactPersonName": contactPersonDetails.contactPersonFirstName,
        "contactPersonFirstname": contactPersonDetails.contactPersonFirstName,
        "contactPersonMiddlename": contactPersonDetails.contactPersonMiddleName,
        "contactPersonLastname": contactPersonDetails.contactPersonLastName,
        "contactPersonGender": contactPersonDetails.contactPersonGender,
        "contactPersonSalutation": contactPersonDetails.contactPersonSalutation,
        "mobileNo": mobileNumber,
        "bankAccountNumber": accountNumber,
        "bankAccountHolderName": accountHolderName,
        "bankBranch": branchName,
        "bankIfscCode": ifscCode,
        "bankName": bankName,
        "panNumber": panNumber,
        "govtIdCardType": govIDType,
        "govtIdCardNumber": govIDNumber,
        "otherGovtCardType": otherIdType?.otherGovtCardType ? otherIdType?.otherGovtCardType : null,
        "emailId": emailId,
        "category": transporterDetails?.category,
        "urn": urn,
        "registrationCompleted": transporterDetails?.registrationCompleted,
        "isOtpValidated": transporterDetails?.isOtpValidated,
        "preregistrationShortlisted": transporterDetails?.preregistrationShortlisted,
        "registrationStatus": getRegistrationStatus(false),
        "scrutinyStatus": null,
        "stakeholderStatus": transporterDetails?.stakeholderStatus,
        "createdOn": transporterDetails?.createdOn,
        "createdBy": transporterDetails?.createdBy,
        "updatedOn": transporterDetails?.updatedOn,
        "updatedBy": transporterDetails?.updatedBy,
        "isActive": 1,
        "acceptedTerms": transporterDetails?.acceptedTerms,
        "isResourceUpdate": getResourceUpdateFlag(),
        "transporterDetail": {
            "id": transporterDetails?.transporterMasters[0]?.id,
            "regStakeholderMasterId": transporterDetails?.transporterMasters[0]?.regStakeholderMasterId,
            "pincode": addressDetails.pincode,
            "address": addressDetails.address,
            "state": addressDetails.state,
            "district": addressDetails.district,
            "subDivision": addressDetails.subDivision,
            "revenueCircle": addressDetails.revenueCircle,
            "blockName": addressDetails.blockName,
            "transportationTradeLicenseNo": tradeLicenseNo,
            "tradeLicenseEndDate": tradeLicenseEndDate,
            "gstNumber": gstNumber,
            "bankStatement": transporterDetails?.transporterMasters[0]?.bankStatement,
            "totalManpower": totalManpower,
            "companyType": transporterDetails?.transporterMasters[0]?.companyType,
            "locationGeocode": transporterDetails?.transporterMasters[0]?.locationGeocode,
            "documentId": transporterDetails?.transporterMasters[0]?.documentId,
            "applicantType": applicantType,
            "noOfLcvVehicleOwned": vehicleDataDisplay.find((item) => item.vehicleType === "LCV")?.ownedVehicles,
            "noOfLcvVehicleRented": vehicleDataDisplay.find((item) => item.vehicleType === "LCV")?.rentedVehicles,
            "noOfMcvVehicleOwned": vehicleDataDisplay.find((item) => item.vehicleType === "MCV")?.ownedVehicles,
            "noOfMcvVehicleRented": vehicleDataDisplay.find((item) => item.vehicleType === "MCV")?.rentedVehicles,
            "noOfHcvVehicleOwned": vehicleDataDisplay.find((item) => item.vehicleType === "HCV")?.ownedVehicles,
            "noOfHcvVehicleRented": vehicleDataDisplay.find((item) => item.vehicleType === "HCV")?.rentedVehicles,
            "existingAreaOfOperation": selectedArea.join(','),
            "certificateType": certificateType,
            "certificateNumber": certificateNumber,
            "agreementStartDate": agreementStartDate,
            "agreementEndDate": agreementEndDate,
            "createdOn": transporterDetails?.transporterMasters[0]?.createdOn,
            "createdBy": transporterDetails?.transporterMasters[0]?.createdBy,
            "updatedOn": transporterDetails?.transporterMasters[0]?.updatedOn,
            "updatedBy": transporterDetails?.transporterMasters[0]?.updatedBy,
            "isActive": transporterDetails?.transporterMasters[0]?.isActive,
            "documents": filteredDocuments,
            "transporterVehicles": dataFromVehiclePopover,
            "transporterDrivers": dataFromDriverPopover,
            "isMSME": isMSMERadio === "YES" ? 1 : 0,
            "msmeCategory": isMSMERadio === "YES" ? msmeCategory : null,
        }
    }

    const updateTransporter = () => {
        apiClient
            .post(UPDATE_TRANSPORTER + `?IsRegistrationSubmit=${getSubmit()}`,
                finalData,
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }
            )
            .then((response) => {
                loaderService.hideLoader();
                const updateGrowerResponse = response?.data
                setCallUpdateApi(false);
                if (updateGrowerResponse?.isSuccess) {
                    getStakeholderDetailsFromUrn();
                    if (buttonAction === "preview") {
                        setCurrentPage("preview")
                    }
                    if (buttonAction === "submit" || buttonAction === "save") {
                        toast.success(updateGrowerResponse?.message);
                    }
                    if (buttonAction === "submit" && userRole === ROLES?.RegistrationScruitnizer && state?.userType === "Internal" && stakeHolderDetails?.scrutinyStatus === "Approved") {
                        onSubmit();
                    }
                    if (buttonAction === "submit") {
                        if (decoded.extension_URN) {
                            navigate('/dashboardHome/dashboardStakeHolder');
                        }
                        else if (userRole === RESOURCE_ROLES.PlantSCMMember) {
                            navigate('/resourcedashboard/searchByURN');
                        }
                        else if (userRole === ROLES.ItAdmin) {
                            navigate('/sidebar/viewAllActiveApplications');
                        }
                        else if (userRole === ROLES.RegistrationScruitnizer && state?.userType === "Internal") {
                            navigate('/registrationHome/dashboard');
                        }
                        else if (userRole === ROLES.RegistrationScruitnizer) {
                            setCallWorkFlowApi(true);
                        }
                        else {
                            navigate(-1);
                        }
                    }
                }
                else {
                    toast.error(updateGrowerResponse?.message);
                    setCurrentPage("registrationDetails")
                }
            })
            .catch(function (error) {
            })

    }

    const onSubmit = () => {
        loaderService.showLoader();
        apiClient.post(INITIATE_WORKFLOW_FOR_REG_SCRU,
            {
                "stakeholderMappings": [
                    {
                        "scrutinizerId": getLocalStorageItem('uuid'),
                        "stakeholderID": stakeHolderDetails?.id,
                        "stakeholderState": stakeHolderDetails?.transporterMasters?.[0]?.state,
                        "stakeholderDistrict": stakeHolderDetails?.transporterMasters?.[0]?.district,
                        "loggedInUserID": getLocalStorageItem('uuid'),
                        "isActive": 1,
                        // "leadScrutinizerID": "3fa85f64-5717-4562-b3fc-2c963f66afa6"
                    }
                ]
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                }
            }, null
        )
            .then((response) => {
                if (response.data.isSuccess === true) {
                    onActionWorflowSubmit();
                } else {
                    toast.error(response.data?.message)
                }
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();

            });
    };

    const onActionWorflowSubmit = () => {
        loaderService.showLoader();
        apiClient.post(ALLOCATE_WORKFLOW,
            {
                "stakeHolderMasterID": stakeHolderDetails?.id,
                "workflowInitiatorID": getLocalStorageItem('uuid'),
                "workflowReceiverID": "",
                "workflowAction": "Approve",
                "status": "",
                "isStakeHolderAction": false,
                "workflowInitiatorRole": localStorage.getItem('role'),
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                }
            }, null
        )
            .then((response) => {
                if (response.data.isSuccess === true) {
                    toast.success(response.data?.message);
                    if (localStorage.getItem('uuid'))
                        navigate('/registrationHome/dashboard');
                    else
                        navigate('/dashboardHome/dashboardStakeHolder');
                } else {
                    toast.error(response.data?.message)
                }
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();

            });
    };

    const noCommentForMandatorySections = () => {
        if (stakeHolderDetails?.scrutinyStatus == "Submited_Clarification") {
            if (comments.find((item) => item.sectionName === "personal_details" && item.scrutinyAction === "Submited_Clarification" && item.isActive === 1) && !comments.find((item) => item.sectionName === "personal_details" && item.createdBy === (decoded.extension_URN ? transporterDetails?.transporterMasters[0]?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null)) {
                setExpandedSection("personal");
                setErrorMessage({ ...errorMessage, personalCommentError: "Please enter comment and save" });
                // toast.error("Please enter Applicant Type");
                return true;
            }
            if (comments.find((item) => item.sectionName === "bank_details" && item.scrutinyAction === "Submited_Clarification" && item.isActive === 1) && !comments.find((item) => item.sectionName === "bank_details" && item.createdBy === (decoded.extension_URN ? transporterDetails?.transporterMasters[0]?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null)) {
                setExpandedSection("bank");
                setErrorMessage({ ...errorMessage, bankCommentError: "Please enter comment and save" });
                // toast.error("Please enter Applicant Type");
                return true;
            }
            if (comments.find((item) => item.sectionName === "agreement_details" && item.scrutinyAction === "Submited_Clarification" && item.isActive === 1) && !comments.find((item) => item.sectionName === "agreement_details" && item.createdBy === (decoded.extension_URN ? transporterDetails?.transporterMasters[0]?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null)) {
                setExpandedSection("agreement");
                setErrorMessage({ ...errorMessage, agreementCommentError: "Please enter comment and save" });
                // toast.error("Please enter Applicant Type");
                return true;
            }
            if (comments.find((item) => item.sectionName === "vehicle_details" && item.scrutinyAction === "Submited_Clarification" && item.isActive === 1) && !comments.find((item) => item.sectionName === "bank_details" && item.createdBy === (decoded.extension_URN ? transporterDetails?.transporterMasters[0]?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null)) {
                setExpandedSection("vehicle");
                setErrorMessage({ ...errorMessage, bankCommentError: "Please enter comment and save" });
                // toast.error("Please enter Applicant Type");
                return true;
            }
        }
        else {
            if (shouldActOnSection.personal_details && !comments.find((item) => item.sectionName === "personal_details" && item.createdBy === (decoded.extension_URN ? transporterDetails?.transporterMasters[0]?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null)) {
                setExpandedSection("personal");
                setErrorMessage({ ...errorMessage, personalCommentError: "Please enter comment and save" });
                // toast.error("Please enter Applicant Type");
                return true;
            }
            if (shouldActOnSection.bank_details && !comments.find((item) => item.sectionName === "bank_details" && item.createdBy === (decoded.extension_URN ? transporterDetails?.transporterMasters[0]?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null)) {
                setExpandedSection("bank");
                setErrorMessage({ ...errorMessage, bankCommentError: "Please enter comment and save" })
                // toast.error("Please enter Applicant Type");
                return true;
            }
            if (shouldActOnSection.agreement_details && !comments.find((item) => item.sectionName === "agreement_details" && item.createdBy === (decoded.extension_URN ? transporterDetails?.transporterMasters[0]?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null)) {
                setExpandedSection("agreement");
                setErrorMessage({ ...errorMessage, agreementCommentError: "Please enter comment and save" });
                // toast.error("Please enter Applicant Type");
                return true;
            }
            if (shouldActOnSection.vehicle_details && !comments.find((item) => item.sectionName === "vehicle_details" && item.createdBy === (decoded.extension_URN ? transporterDetails?.transporterMasters[0]?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null)) {
                setExpandedSection("vehicle");
                setErrorMessage({ ...errorMessage, vehicleCommentError: "Please enter comment and save" })
                // toast.error("Please enter Applicant Type");
                return true;
            }
        }
        return false
    }

    const showPreview = () => {
        if (showCommentSection && (noCommentForMandatorySections())
        ) {
            toast.error("Please enter comments for required sections");
        }
        else {
            Object.keys(finalData?.transporterDetail).forEach((key) => {
                if (!_.isEqual(finalData?.transporterDetail[key], initialData?.transporterDetail[key])) {
                    console.log(`Mismatch at key: ${key}`);
                    console.log('Initial:', initialData?.transporterDetail[key]);
                    console.log('Final:', finalData?.transporterDetail[key]);
                }
            });
            setErrorMessage({ ...errorMessage, landDetailsError: "" });
            enableSaveSubmitButtons && !_.isEqual(finalData, initialData) ? setCallUpdateApi(true) : setCurrentPage("preview");
            setButtonAction("preview")
        }
    }

    const onGoBack = () => {
        setCurrentPage("registrationDetails")
    }

    return (
        <TransporterContext.Provider value={{
            userType: state?.userType, viewOnly: state?.viewOnly, regScruResourceUpdate, setRegScruResourceUpdate, transporterDetails, tradeLicenseEndDate, setTradeLicenseEndDate, setTradeLicenseEndDateDisplay, tradeLicenseEndDateDisplay, fullName, setFullName, documentArray, setDocumentArray, mobileNumber, setMobileNumber, setMobileNumberError, emailId, panNumber, setPanNumber, tradeLicenseNo, setTradeLicenseNo, setAccountNumber, accountNumber, accountHolderName, setAccountHolderName, setBankName, ifscCode, setIfscCode, contactPersonDetails, setContactPersonDetails, certificateType, setCertificateType, otherIdType, setOtherIdType, addressDetails, setAddressDetails, certificateNumber, setCertificateNumber, otpValue, setOtpValue, verifyMobileNo, setVerifyMobileNo, otpHidden, setOtpHidden, mobileOTPValidated, setMobileOTPValidated, bankDetails, setBankDetails, branchName, setBranchName, applicantType, setApplicantType, totalManpower, setTotalManpower, dataFromDriverPopover, setDataFromDriverPopover, dataFromVehiclePopover, setDataFromVehiclePopover, agreementStartDate, agreementStartDisplay, agreementEndDate, agreementEndDisplay, setVehicleCount, totalVehicleCount, gstNumber, setGstNumber, selectedArea, setSelectedArea, vehicleDataDisplay, setVehicleDataDisplay, selectedAreaApi, setSelectedAreaApi, setAgreementStartDate, setAgreementEndDate, setAgreementStartDisplay, setAgreementEndDisplay, personalDetailsSectionOk, setPersonalDetailsSectionOk, bankDetailsSectionOk, setBankDetailsSectionOk, agreementDetailsSectionOk, setAgreementDetailsSectionOk, vehicleDetailsSectionOk, setVehicleDetailsSectionOk, shouldActOnSection, setShouldActOnSection, showWorkFlowButtons, showClarificationButton, enableSaveSubmitButtons, stakeHolderDetails, showCommentSection, commentsData, setCommentsData, registerByScruOtpValidated: state?.registerByScruOtpValidated, comments, setComments, enableFieldFunction, currentPage, buttonAction, setCurrentPage, setButtonAction, errorMessage, setErrorMessage, expandedSection, setExpandedSection, setCallUpdateApi, setCallUpdateApi, callWorkFlowApi, isMSMERadio,
            setIsMSMERadio,
            msmeCategory,
            setMsmeCategory,
        }}>
            <>
                {currentPage === "registrationDetails" && transporterDetails && <Container maxWidth="xxl" >
                    {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>REG26</p>}
                    <Stack direction="row" alignItems="center" spacing={1} mb={3}>
                        <BackButton navigate={navigate} />
                        <Typography variant="h5" gutterBottom>
                            {t('reg.registrationDetails')}
                        </Typography>
                    </Stack>
                    <Grid container spacing={2}>
                        <Grid item xs={12} lg={12}>
                            <TextField
                                required
                                disabled
                                type="text"
                                label="URN"
                                value={urn || ''}
                            />
                        </Grid>
                        <PersonalDetailsTransporter />
                        <VehicleDetailsTransporter />
                    </Grid>
                    <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
                        {!showWorkFlowButtons &&
                            <Button
                                sx={{ minWidth: 100 }}
                                variant="contained"
                                disabled={!enableSaveSubmitButtons || state?.viewOnly}
                                onClick={() => { (!_.isEqual(finalData, initialData) ? setCallUpdateApi(true) : toast.warning("No modifications to be saved")); setButtonAction("save"); }}
                                startIcon={<SaveIcon />}
                            >{t('preReg.save')}
                            </Button>
                        }
                        <Button
                            sx={{ minWidth: 100, ml: 1 }}
                            variant="contained"
                            onClick={() => checkValidations()}
                            startIcon={<PreviewIcon />}
                        >{t('preReg.preview')}</Button>
                    </Box>
                </Container>}
                {currentPage === "preview" &&
                    <Grid xs={12} md={12} id='divPreview'>
                        <Preview urn={urn} goBack={onGoBack} callWorkFlowApi={callWorkFlowApi} stakeholderType="Transporter" />
                    </Grid>}
            </>
        </TransporterContext.Provider>
    );
}
export default RegistrationDetailsTransporter;
export const useTransporterContextData = () => useContext(TransporterContext)